// This is a mixin which provides an object with the ability to set and manage a StateMachine.
// Pass in obj to extend the obj's prototype with the methods.

export function MixinStateMachine(obj) {
    mixinMethods(obj);
}

function mixinMethods(obj) {

    // Add a placeholder handleStateChange method unless it already exists.
    if (typeof obj.handleStateChange !== 'function') {
        Object.assign(obj.__proto__, { handleStateChange: ()=>{} });
    }

    Object.assign(obj.__proto__, {

        setStateMachine(stateMachine) {
            if (isStateMachine(stateMachine)) {
                this.stateMachine = stateMachine;
                this.unsubscribeStateMachine = this.stateMachine.events.subscribe('stateChange', () => {
                    this.handleStateChange();
                });
            }
        },

        // Detach from the state machine's `stateChange` event and drop the reference.
        // A shared state machine outlives the components using it (see the state-machine
        // singleton pattern), so a component that goes away without detaching keeps being
        // rendered forever. `Component#destroy` calls this.
        unsetStateMachine() {
            if (typeof this.unsubscribeStateMachine === 'function') this.unsubscribeStateMachine();
            this.unsubscribeStateMachine = null;
            this.stateMachine = null;
        },

        getStateMachine() {
            return this.stateMachine ? this.stateMachine : null;
        },

        getStateMachineState() {
            const sm = this.getStateMachine();
            return sm ? sm.state : {};
        },

        // The stateable object is usually the object which is being managed by the state machine.
        // This method allows us to get a reference to the stateable object within the state machine and its actions by using the state machine's `getStateableObject()` method.
        setStateableObject(Obj) {
            this.stateMachine.getStateableObject = () => Obj;
        },

        readStateMachineValue(stateKey) {
            const state = this.getStateMachineState();
            const value = state[stateKey];
            return typeof value === "undefined" ? null : value;
        },

        // @deprecated - Deprecated method - use `readStateMachineValue` instead.
        readState(stateKey) {
            return this.readStateMachineValue(stateKey);
        },

        dispatchAction(actionKey, payload) {
            if (arguments.length > 2) console.warn(`[stateable.js] dispatchAction() called with ${arguments.length} arguments. Only the first two arguments will be used.`, arguments);
            const sm = this.getStateMachine();
            if (!sm) {
                console.error(
                    "[stateable.js] dispatchAction() StateMachine instance not found!: ",
                    this,
                );
                return;
            }
            sm.dispatch(actionKey, payload);
        },

        dispatchTouch() {
            const sm = this.getStateMachine();
            sm.touch();
        }

    });
}

// Here we only test if the passed in `sm` quacks like a `StateMachine`.
// Ideally we'd do `sm instanceof StateMachine`, however due to esbuild bundling we don't have only one `StateMachine`.
// FIXME - Ensure that esbuild is not bloated with multiple `StateMachine`s.
function isStateMachine(sm) {
    return (
        sm &&
        typeof sm.dispatch === "function" &&
        sm.events &&
        typeof sm.events.subscribe === "function"
    );
}
